<template>

  <div id="interface" v-if="locale.interface">
    <div class="overlay" @click="closeMenu"></div>
    <div class="cloud-server-page">
      <div class="sidebar-menu" v-bind:class="{'show-hide-menu': menuActive }">
        <div class="sidebar-menu__cloudserver">
          <p>{{locale.interface.cloudserver}}</p>
          <div class="sidebar-menu__close-button" @click="closeMenu"></div>
        </div>
        <div class="sidebar-menu__control-button-wrapper">
          <div class="main-header__profile-info">
            <img src="../assets/startseite_hintergrund.jpg" alt="">
            <p>{{$store.state.user.lastName }}</p>
          </div>
          <router-link to="/" class="main-header__messages-button">
          </router-link>
          <router-link class="sidebar-menu__button-wrapper" to="/">
            <button type="submit" class="button button--with-border sidebar-menu__logout-button" v-on:click="logOutAction">{{locale.interface.logout}}</button>
          </router-link>
        </div>
        <div class="sidebar-menu__wrapper" @click="closeMenu">
          <ul class="sidebar-menu__list">
            <li class="sidebar-menu__list-item">
              <router-link class="nav-link sidebar-menu__link sidebar-menu__link--barchart" to="/app/computes">
                {{locale.interface.computes}}
              </router-link>
              <ul class="sidebar-menu__list sidebar-menu__list--lvl-2">
                <li class="sidebar-menu__list-item sidebar-menu__list-item--lvl-2">
                  <router-link class="nav-link sidebar-menu__link sidebar-menu__link--lvl-2 sidebar-menu__link--volume" to="/app/volumes">
                    {{locale.interface.volume}}
                  </router-link>
                </li>
                <li class="sidebar-menu__list-item sidebar-menu__list-item--lvl-2">
                  <router-link class="nav-link sidebar-menu__link sidebar-menu__link--lvl-2 sidebar-menu__link--floating" to="/app/floating">
                    {{locale.interface.floating}}
                  </router-link>
                </li>
                <li class="sidebar-menu__list-item sidebar-menu__list-item--lvl-2">
                  <router-link class="nav-link sidebar-menu__link sidebar-menu__link--lvl-2 sidebar-menu__link--snapshot" to="/app/snapshots">
                    {{locale.interface.snapshots}}
                  </router-link>
                </li>
                <li class="sidebar-menu__list-item sidebar-menu__list-item--lvl-2">
                  <router-link class="nav-link sidebar-menu__link sidebar-menu__link--lvl-2 sidebar-menu__link--securitygroups" to="/app/firewall">
                    {{locale.interface.securitygroups}}
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="sidebar-menu__list-item">
              <router-link class="nav-link sidebar-menu__link sidebar-menu__link--user" to="/app/user">
                {{locale.interface.user}}
              </router-link>
              <ul class="sidebar-menu__list sidebar-menu__list--lvl-2">
                <li class="sidebar-menu__list-item sidebar-menu__list-item--lvl-2">
                <router-link class="nav-link sidebar-menu__link sidebar-menu__link--lvl-2 sidebar-menu__link--keypairs" to="/app/keypairs">
                  {{locale.interface.keypairs}}
                </router-link>
                </li>
              </ul>
            </li>
            <li class="sidebar-menu__list-item">
              <router-link class="nav-link sidebar-menu__link sidebar-menu__link--logs" to="/app/logs">
                {{locale.interface.logs}}
              </router-link>
            </li>
            <li class="sidebar-menu__list-item">
              <router-link class="nav-link sidebar-menu__link sidebar-menu__link--billing" to="/app/billing">
                {{locale.interface.billing}}
              </router-link>
              <ul class="sidebar-menu__list sidebar-menu__list--lvl-2">
                <li class="sidebar-menu__list-item sidebar-menu__list-item--lvl-2">
                  <router-link class="nav-link sidebar-menu__link sidebar-menu__link--lvl-2 sidebar-menu__link--billing" to="/app/interimBilling">
                    {{locale.interface.interimBilling}}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="wrap-content">
        <div class="main-header">
          <div class="main-header__left-content">
            <div class="main-header__logo-wrapper">
                <img src="../assets/logo.svg" alt="mobilistics" class="logo">
            </div>
          </div>

          <div id="burger_menu" class="main-header__burger-menu" @click="openMenu">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
          </div>

          <div class="main-header__right-content">
            <div class="main-header__profile-info">
              <img src="../assets/startseite_hintergrund.jpg" alt="">
              <p>{{ $store.state.user.lastName }}</p>
            </div>
            <router-link to="/" class="main-header__messages-button">
            </router-link>
            <router-link class="main-header__button-wrapper" to="/">
              <button type="submit" class="button" v-on:click="logOutAction">{{locale.interface.logout}}</button>
            </router-link>
          </div>
        </div>
        <div class="main-content">
          <main role="main">
            <router-view/>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Interface',
  computed: {
    ...mapState(['locale'])
  },
  data () {
    return {
      menuActive: false
    }
  },
  methods: {
    logOutAction () {
      window.sessionStorage.clear()
    },
    openMenu () {
      this.menuActive = true
      document.body.classList.add('noScroll')
      var element = document.querySelector('.overlay')
      element.classList.add('show')
    },
    closeMenu () {
      this.menuActive = false
      document.body.classList.remove('noScroll')
      var element = document.querySelector('.overlay')
      element.classList.remove('show')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Interface.vue